module.exports = __webpack_public_path__ + "static/media/FotosZu.1f56912a.jpeg";